const API_BASE_URL = "https://telco.contacta.mx";

export const API_ROUTES = {
  // Auth routes
  login: `${API_BASE_URL}/auth/login`,
  logout: `${API_BASE_URL}/auth/logout`,
  refreshSession: `${API_BASE_URL}/auth/refresh-session`,
  me: `${API_BASE_URL}/auth/me`,

  // Endpoints separados por modo y tipo
  resumen: {
    admin: {
      mensual: `${API_BASE_URL}/reportes/admin/resumen-mensual`,
      diario: `${API_BASE_URL}/reportes/admin/resumen-diario`,
    },
    cliente: {
      mensual: `${API_BASE_URL}/reportes/cliente/resumen-mensual`,
      diario: `${API_BASE_URL}/reportes/cliente/resumen-diario`,
    },
  },

  resumenMensual: `${API_BASE_URL}/reportes/resumen-mensual`,
  resumenDiario: `${API_BASE_URL}/reportes/resumen-diario`,

  empresas: `${API_BASE_URL}/reportes/empresas`,
  clientes: (empresa) => `${API_BASE_URL}/reportes/clientes?empresa=${empresa}`,
  paises: (empresa, cliente = "") =>
    `${API_BASE_URL}/reportes/paises?empresa=${empresa}&cliente=${cliente}`,
  reporteResumenGeneral: `${API_BASE_URL}/reportes/reporte-resumen-general`,
  tarifas: `${API_BASE_URL}/reportes/tarifas`,
  monitorEmpresas: `${API_BASE_URL}/monitor/empresas`,
  monitorClientes: (empresaId) =>
    `${API_BASE_URL}/monitor/clientes?empresa_id=${empresaId}`,
  monitorMeses: `${API_BASE_URL}/monitor/meses`,
  monitorDetalle: `${API_BASE_URL}/monitor/detalle`,
  monitorDetallePrecio: `${API_BASE_URL}/monitor/detalle-llamada`,
  monitorDescargarCompleto: `${API_BASE_URL}/monitor/descargar-completo`,
  calendarEmpresas: `${API_BASE_URL}/calendar/empresas`,
  calendarFechas: (empresaId, anio) =>
    `${API_BASE_URL}/calendar/calendario?empresa_id=${empresaId}&anio=${anio}`,
  calendarDescargar: (empresaId, fecha) =>
    `${API_BASE_URL}/calendar/descargar-dia?empresa_id=${empresaId}&fecha=${fecha}`,
  calendarDescargarZip: (empresaId, desde, hasta) =>
    `${API_BASE_URL}/calendar/descargar-zip?empresa_id=${empresaId}&desde=${desde}&hasta=${hasta}`,
  listadoEmpresas: `${API_BASE_URL}/listado/empresas`,
  listadoClientes: `${API_BASE_URL}/listado/clientes`,
  calendarDescargarMes: (empresaId, anio, mes) =>
    `${API_BASE_URL}/calendar/descargar-mes?empresa_id=${empresaId}&anio=${anio}&mes=${mes}`,

  // Crear listado de empresa, cliente y tarifas
  listadoCrearTodo: `${API_BASE_URL}/listado/crear-todo`,
  listadoCrearPerfilTarifas: `${API_BASE_URL}/listado/perfil-tarifas`,
  listadoCrearTarifasConPerfilId: `${API_BASE_URL}/listado/perfil-tarifas/existente`,
  listadoCrearPerfilTarifasNuevo: `${API_BASE_URL}/listado/perfil-tarifas/nuevo`,
  listadoEmpresasClientes: `${API_BASE_URL}/listado/empresas-clientes`,
  listadoPerfilesTarifa: `${API_BASE_URL}/listado/perfiles`,
  listadoAsignarPerfil: `${API_BASE_URL}/listado/asignar-perfil`,
  listadoNombrarPerfilTarifas: `${API_BASE_URL}/listado/perfiles_tarifas/nombrar`,
  listadoPerfilesTarifas: `${API_BASE_URL}/listado/perfiles_tarifas`,

  empresaTarifas: (empresaId) =>
    `${API_BASE_URL}/listado/empresa/${empresaId}/tarifas`,

  // Finanzas (empresa "por id") — se mantienen para compatibilidad
  resumenEmpresa: (empresaId) =>
    `${API_BASE_URL}/finanzas/empresa/${empresaId}/resumen`,
  movimientos: (empresaId, clienteId) =>
    `${API_BASE_URL}/finanzas/empresa/${empresaId}/movimientos${
      clienteId ? `?cliente_id=${clienteId}` : ""
    }`,

  // Finanzas por sesión (cookie)
  resumenEmpresaSesion: `${API_BASE_URL}/finanzas/empresa/resumen`,
  movimientosSesion: `${API_BASE_URL}/finanzas/empresa/movimientos`,

  // Finanzas aislado para ADMIN
  adminFinanzas: {
    resumenEmpresa: (empresaId) =>
      `${API_BASE_URL}/admin/finanzas/empresa/${empresaId}/resumen`,
    movimientos: (empresaId, clienteId) =>
      `${API_BASE_URL}/admin/finanzas/empresa/${empresaId}/movimientos${
        clienteId ? `?cliente_id=${clienteId}` : ""
      }`,
  },

  setLimiteEmpresa: `${API_BASE_URL}/finanzas/empresa/limite-credito`,
  depositoEmpresa: `${API_BASE_URL}/finanzas/empresa/deposito`,
  extraEmpresa: `${API_BASE_URL}/finanzas/empresa/extra`,
  setLimitesCliente: `${API_BASE_URL}/finanzas/cliente/limites`,
  setDepositoCliente: `${API_BASE_URL}/finanzas/cliente/deposito-asignado`,
  ensureEmpresa: `${API_BASE_URL}/finanzas/ensure/empresa`,
  ensureCliente: `${API_BASE_URL}/finanzas/ensure/cliente`,
  transferirDeposito: `${API_BASE_URL}/finanzas/deposito/transferir`,

  // CDR Pipeline endpoints
  cdrPipeline: {
    base: `${API_BASE_URL}/cdr-pipeline`,
    process: `${API_BASE_URL}/cdr-pipeline/process`,
    status: `${API_BASE_URL}/cdr-pipeline/status`,
    download: `${API_BASE_URL}/cdr-pipeline/download`,
    history: `${API_BASE_URL}/cdr-pipeline/history`,
    stats: `${API_BASE_URL}/cdr-pipeline/stats`,
  },

  // ===== CSV PROCESSOR (LOGS) =====
  csvProcessor: {
    logsStreamBase: `${API_BASE_URL}/csv-processor/logs`,
    logsStream: (jobId) => `${API_BASE_URL}/csv-processor/logs/${jobId}/stream`,
  },

  // Productos
  productosList: `${API_BASE_URL}/productos`,
  productosCreate: `${API_BASE_URL}/productos`,
  productosUpdate: `${API_BASE_URL}/productos`,
  productosDelete: `${API_BASE_URL}/productos`,

  // Perfiles - CRUD completo
  perfiles: `${API_BASE_URL}/perfiles`,
  perfilDetalle: (id) => `${API_BASE_URL}/perfiles/${id}`,
  perfilCreate: `${API_BASE_URL}/perfiles`,
  perfilUpdate: (id) => `${API_BASE_URL}/perfiles/${id}`,
  perfilDelete: (id) => `${API_BASE_URL}/perfiles/${id}`,

  // Usuarios
  usuariosList: `${API_BASE_URL}/usuarios`,
  usuarioDetalle: (id) => `${API_BASE_URL}/usuarios/${id}`,
  usuarioCreate: `${API_BASE_URL}/usuarios`,
  usuarioUpdate: (id) => `${API_BASE_URL}/usuarios/${id}`,
  usuarioToggleEnabled: (id) => `${API_BASE_URL}/usuarios/${id}/toggle-enabled`,
  usuarioDelete: (id) => `${API_BASE_URL}/usuarios/${id}`,

  // Data para selects
  usuariosEmpresas: `${API_BASE_URL}/usuarios/data/empresas`,
  usuariosClientes: (empresaId) =>
    `${API_BASE_URL}/usuarios/data/clientes/${empresaId}`,
  usuariosPerfiles: `${API_BASE_URL}/usuarios/data/perfiles`,

  // Endpoint para fecha de corte
  fechaCorte: `${API_BASE_URL}/csv/logs/fecha-corte`,

  // Cargos Recurrentes
  cargosRecurrentes: {
    crear: `${API_BASE_URL}/cargos-recurrentes`,
    listar: (empresaId) =>
      `${API_BASE_URL}/cargos-recurrentes?empresa_id=${empresaId}`,
    desactivar: (id, empresaId) =>
      `${API_BASE_URL}/cargos-recurrentes/${id}/desactivar?empresa_id=${empresaId}`,
    reactivar: (id, empresaId) =>
      `${API_BASE_URL}/cargos-recurrentes/${id}/reactivar?empresa_id=${empresaId}`,
    historial: (id, empresaId) =>
      `${API_BASE_URL}/cargos-recurrentes/${id}/historial?empresa_id=${empresaId}`,
    onepbxActivos: (empresaId) =>
      `${API_BASE_URL}/cargos-recurrentes/onepbx-activos?empresa_id=${empresaId}`,
  },

  // Grabaciones
  grabaciones: {
    url: (year, month, day, filename) =>
      `${API_BASE_URL}/audios/${year}/${month}/${day}/${filename}`,
    list: (year, month, day) =>
      `${API_BASE_URL}/audios/list/${year}/${month}/${day}`,
  },

  authrules: {
    opciones: `${API_BASE_URL}/authrules/opciones`,
    reglas: `${API_BASE_URL}/authrules/reglas`,
    catalogo: `${API_BASE_URL}/authrules/catalogo`,
    blaster: `${API_BASE_URL}/authrules/blaster`,
    historial: `${API_BASE_URL}/authrules/historial`,
    masivo: `${API_BASE_URL}/authrules/masivo`,
  },

  // Analisis (CPS / sesiones simultaneas)
  analisis: {
    cps: `${API_BASE_URL}/analisis/cps`,
    meses: `${API_BASE_URL}/analisis/meses`,
    dias: `${API_BASE_URL}/analisis/cps/dias`,
    horas: `${API_BASE_URL}/analisis/cps/horas`,
  },

  // Trafico por result (descarga de reportes clearcom_resumen_30min)
  trafico: {
    meses: `${API_BASE_URL}/trafico/meses`,
    excel: `${API_BASE_URL}/trafico/excel`,
    comparar: `${API_BASE_URL}/trafico/comparar`,
    compararExcel: `${API_BASE_URL}/trafico/comparar/excel`,
  },
};
